import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalSiteSettingsState,
  selectSiteSettings,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import PipelineCommissionFeeEditor from '../components/PipelineCommissionFeeEditor'

export default connect(
  createStructuredSelector<
    ApplicationState,
    ICurrentUserState & IGlobalSiteSettingsState
  >({
    siteSettings: selectSiteSettings(),
    user: selectCurrentUser(),
  }),
)(PipelineCommissionFeeEditor)
